import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {AgendaCalendarDataService} from './impl/service/ngrx/agendaCalendarData.service';
import {AgendaCalendarRepository} from './impl/service/ngrx/agendaCalendar.repository';
import {errorMessages} from '../../../core/error/errorMessages';

@NgModule()
export class CalendarModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                calendarDataService: AgendaCalendarDataService,
                calendarService: AgendaCalendarRepository,
    ) {

        entityDataService.registerServices({
            AgendaCalendar: calendarDataService,
        });

        entityServices.registerEntityCollectionServices({
            AgendaCalendar: calendarService,
        });

        errorMessages.set('AGENDA_CALENDAR_SAVE_GOOGLE_CALENDAR_DOES_NOT_EXIST', 'Le calendrier Google n\'existe pas.');
        errorMessages.set('AGENDA_CALENDAR_SAVE_NAME_ALREADY_USED', 'Un calendrier existe déjà avec ce libellé');
    }
}
